/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  SuccessResponseData,
  SuccessResponseDataFromJSON,
  SuccessResponseDataFromJSONTyped,
  SuccessResponseDataToJSON
} from './SuccessResponseData'

/**
 *
 * @export
 * @interface BulkDestroyDocumentsResponse
 */
export interface BulkDestroyDocumentsResponse {
  /**
   *
   * @type {number}
   * @memberof BulkDestroyDocumentsResponse
   */
  status?: number
  /**
   *
   * @type {SuccessResponseData}
   * @memberof BulkDestroyDocumentsResponse
   */
  data?: SuccessResponseData
}

export function BulkDestroyDocumentsResponseFromJSON(json: any): BulkDestroyDocumentsResponse {
  return BulkDestroyDocumentsResponseFromJSONTyped(json, false)
}

export function BulkDestroyDocumentsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BulkDestroyDocumentsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : SuccessResponseDataFromJSON(json['data'])
  }
}

export function BulkDestroyDocumentsResponseToJSON(value?: BulkDestroyDocumentsResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: SuccessResponseDataToJSON(value.data)
  }
}
